import app from "@/common/plugins/vueInstance";
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";

app.component("circle-progress", CircleProgress);
